<template>
  <div id="container">

    <div v-if="isWarehousePIC">
      <div v-if="showMainMenu == 'main'" class="h-screen flex w-full bg-img p-5">

        <div class="vx-col flex items-center justify-center flex-col  mx-auto text-center">
          <div class="vx-row">
            <div class="vx-col  w-full mb-10">
              <img style="height:80px;width: auto;" src="@/assets/images/logo/rescope.png" alt="login" class="mx-auto" />
            </div>

            <div @click="showGoodsMovement('gr')" class="vx-col   w-1/2 md:w-1/2 xl:w-1/2 cursor-pointer">
              <statistics-card-line hideChart class="mb-base" icon="LogInIcon" statistic="GR" :statisticTitle="grCount" />

            </div>

            <div @click="showGoodsMovement('gs')" class=" vx-col w-1/2 md:w-1/2 xl:w-1/2 cursor-pointer">
              <statistics-card-line hideChart class="mb-base" icon="TruckIcon" :statisticTitle="gsCount" statistic="GS"
                color='success' />
            </div>

            <div @click="showMainMenu = 'st'" class="vx-col w-full cursor-pointer">
              <statistics-card-line hideChart class="mb-base" icon="EditIcon" statistic="ST" statisticTitle=""
                color='warning' />
            </div>

          </div>
          <vs-button size="large" to="/login">Logout</vs-button>
        </div>
      </div>
      <div v-else-if="showMainMenu == 'st'">
        <stocktakeScan @close="showMainMenu = 'main'"></stocktakeScan>
      </div>
      <div v-else>
        <goodsMovement @close="showMainMenu = 'main'; getPendingCount()" :subject="subject" />
      </div>
    </div>
    <div v-else>
      <div class="h-screen flex w-full bg-img">
        <div
          class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
          <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
          <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color">Not Authorized!</h1>
          <p class="sm:mx-0 mx-4 mb-4 sm:mb-16 text-danger "><strong>
              Sorry only WAREHOUSE PIC can access this Page!
            </strong> </p>
          <vs-button size="large" to="/login">Back to Home</vs-button>
        </div>
      </div>

    </div>



  </div>
</template>
<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import { axiosMixin } from '../../mixin/axiosMixin';
import goodsMovement from './goodsMovement.vue';
import stocktakeScan from './stocktakeScan.vue';
import { mapGetters } from "vuex";
export default {
  mixins: [axiosMixin],
  components: {
    StatisticsCardLine,
    goodsMovement,
    stocktakeScan
  },
  data() {
    return {
      grCount: 0,
      gsCount: 0,
      showMainMenu: 'main',
      subject: '',
      isWarehousePIC: false
    };
  },
  computed: {
    ...mapGetters({
      getUserInfo: "auth/getUserInfo",
    }),
  },
  methods: {
    showGoodsMovement(subject) {
      this.subject = subject
      this.showMainMenu = 'gsgr';
    },
    startLoading() {
      this.$vs.loading({
        container: '#container',
        scale: 0.6
      });
    },
    stopLoading() {
      this.$vs.loading.close('#container > .con-vs-loading');
    },
    getPendingCount() {
      this.startLoading();
      this.aronPost('getPendingCount', {}, '', '')
        .then(response => {
          if (response.status) {
            this.grCount = response.data.grCount;
            this.gsCount = response.data.gsCount;
          } else {
            this.errorAlert('Error', response.data.error)
          }

          this.stopLoading()
        })
        .catch(error => {
          console.log('error:', error)
          this.stopLoading()
        })

    }

  },
  mounted() {

    //this.getUserInfo.role contain 'Warehouse PIC'
    if (this.getUserInfo.role.includes('Warehouse PIC')) {
      this.isWarehousePIC = true;
      this.getPendingCount();
    } else {
      this.isWarehousePIC = false;
    }


    // if (this.getUserInfo.role == "Warehouse PIC") {
    //   this.isWarehousePIC = true;
    //   this.getPendingCount();
    // } else {
    //   this.isWarehousePIC = false;
    // }

  },
  created() {

  }
};
</script>
<style scoped>
/* cursor point */
.cursor-pointer {
  cursor: pointer;
}
</style>
